<template>
  <div class="page-pop-card">
    <div class="pop-card-title">{{ title }}</div>
  </div>
</template>
<script>
// const pop = require('../../assets/pop.png')
export default {
  name: 'PagePopCard',
  inject: {
    title: { default: '证书查询' }
  },
  data() {
    return { }
  }
}
</script>
<style lang="stylus" scoped src="./page-pop-card.styl"></style>
